export const brandBgIsInUse = {
  type: "boolean"
};
